import { Button, Text, useDisclosure } from '@chakra-ui/react';
import StrategyType from 'enums/modules/strategies/strategyType';
import useCurrencyText from 'hooks/shared/useCurrencyText';
import AppCard from 'presentation/components/shared/card/AppCard';
import RequestServiceManagerCallModal from 'presentation/containers/modules/services/RequestServiceManagerCallModal';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ServiceModalData {
  serviceId: StrategyType;
  title: string;
  text: string;
}

interface Props {
  name: string;
  id: StrategyType;
  amount: number;
  currency: Currency;
}

const StrategyApplyCard: FC<Props> = ({ name, id, amount, currency }) => {
  const { t } = useTranslation();

  const {
    isOpen: isServiceManagerCallOpen,
    onClose: onServiceManagerCallClose,
    onOpen: onServiceManagerCallOpen,
  } = useDisclosure();

  const [serviceModalData, setServiceModalData] =
    useState<ServiceModalData | null>(null);

  const currencyText = useCurrencyText();

  return (
    <AppCard p="15px">
      <Text mb="10px">{t('strategyEntryThreshold')}</Text>
      <Text mb="10px" fontSize="30px" fontWeight={700}>
        {currencyText(amount, { symbol: currency.symbol })}
      </Text>
      <Button
        w="full"
        onClick={() => {
          setServiceModalData({
            serviceId: id,
            title: name,
            text: t('requestCallManagerStrategyText'),
          });
          onServiceManagerCallOpen();
        }}
      >
        {t('strategyApply')}
      </Button>

      {serviceModalData && (
        <RequestServiceManagerCallModal
          text={serviceModalData.text}
          title={serviceModalData.title}
          isOpen={isServiceManagerCallOpen}
          onClose={onServiceManagerCallClose}
          serviceId={serviceModalData.serviceId}
        />
      )}
    </AppCard>
  );
};

export default StrategyApplyCard;
